import { Component, Input, OnInit } from '@angular/core';
import { AlarmOverview, Application } from '../../../interfaces/alarm';
import { Observable } from 'rxjs';
import { DataPointsResult, SystemDevice } from '../../../interfaces/data-points';
import { getPumpOptions, getPumpType, systemsToPumpDevice } from '../../../utils/data-point-utils';
import { SchematicsService } from '../../../services/schematics.service';
import { AppModel } from '@ams/dumbledore';
import { PumpOption } from 'projects/customerportal/src/app/services/installation-configuration.service';
import { Installation } from '../../../interfaces/facilty';
import { MixitX509BannerComponent } from '../../mixit-x509-banner/mixit-x509-banner.component';
import { AsyncPipe } from '@angular/common';
import { AlarmBarComponent } from '../../alarms/alarm-bar/alarm-bar.component';
import { SchematicsTileComponent } from '../../schematics-tile/schematics-tile.component';
import { PumpStatusTileComponent } from '../../pump-status-tile/pump-status-tile.component';
import { HeatMeterStatusTileComponent } from '../../heat-meter-status-tile/heat-meter-status-tile.component';
import { ForwardReturnChartTileComponent } from '../../charts/forward-return-chart-tile/forward-return-chart-tile.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-boiler-dashboard',
    templateUrl: './boiler-dashboard.component.html',
    styleUrls: ['./boiler-dashboard.component.scss'],
    imports: [
    MixitX509BannerComponent,
    AlarmBarComponent,
    SchematicsTileComponent,
    PumpStatusTileComponent,
    HeatMeterStatusTileComponent,
    ForwardReturnChartTileComponent,
    TranslateModule,
    AsyncPipe
]
})
export class BoilerDashboardComponent implements OnInit {
  @Input() public alarm$: Observable<AlarmOverview>;
  @Input() public application: Application;
  @Input() public installation$: Observable<Installation>;
  @Input() public schematic$: Observable<AppModel>;
  @Input() public dataPoints$: Observable<DataPointsResult>;

  public pumpType$: Observable<string>;
  public pumpDevice$: Observable<SystemDevice | undefined>;
  public pumpOptions$: Observable<PumpOption[] | undefined>;

  constructor(private schematicsService: SchematicsService) {}

  ngOnInit(): void {
    this.pumpDevice$ = this.dataPoints$.pipe(systemsToPumpDevice(this.application.id));

    this.pumpType$ = getPumpType(this.schematic$, this.application.id);

    this.pumpOptions$ = getPumpOptions(this.pumpDevice$, this.schematicsService, this.application.id);
  }
}
